export default __webpack_public_path__ + "static/balance.url-3481eea15c47ed142d32a63065e2d128.svg";